module.exports = __webpack_public_path__ + "img/LDSJ_STILL12.bf7923a9.jpg";